import LibraryElementEnum from 'client/enums/LibraryElementEnum'
import { usePage } from 'client/store'
import pageSelectors from 'client/store/page/pageSelectors'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { libraryItems } from 'src/editor/layout/sidebar/library/library-items'
import { SettingsNestedMenu } from 'src/editor/layout/sidebar/settings/settings-nested-menu'
import { WebsiteLibraryElementsCreator } from 'src/editor/pages/website/website-library-elements-creator'
import { Toggle } from 'src/editor/shared/ui-lib/toggle/toggle'
import { MenuInterface } from 'src/shared/types/entities/menu'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'
import { WebsiteHeaderInterface } from 'src/shared/types/website-entities'
import { getToggleConfigItems } from 'src/shared/utils/website-header-utils'
import { WebsiteMenuSettings } from '../../settings/menu-settings/website-menu-settings'
import { WebsiteLogoSettings } from '../website-logo/website-logo-settings'
import { useElement } from './hooks/use-element'
import { WebsiteHeaderLibraryElement } from './website-header-library-element'

interface WebsiteHeaderElementsProps {
  entity: WebsiteHeaderInterface
}

export const WebsiteHeaderElements = ({
  entity,
}: WebsiteHeaderElementsProps) => {
  const { toggleElement, getToggleValue } = useElement({ entity })
  const { t } = useTranslation()
  const toggleConfig = getToggleConfigItems()

  const websiteLogoEntity = usePage(page =>
    pageSelectors.getEntityById(page, entity.childIds[0]),
  )
  const menuEntity = usePage(page =>
    pageSelectors.getEntityById(page, entity.childIds[1]),
  )
  const defaultMenuEntity = new WebsiteLibraryElementsCreator().create(
    LibraryElementEnum.LibraryMenu,
  )

  const isLogoEntity =
    websiteLogoEntity && websiteLogoEntity.type === EntityTypeEnum.WebsiteLogo
  const isMenuEntity = menuEntity && menuEntity.type === EntityTypeEnum.Menu

  return (
    <div className="flex flex-col gap-2">
      {isMenuEntity && (
        <SettingsNestedMenu
          menuTitle={t(libraryItems[LibraryElementEnum.LibraryMenu]?.title)}
          menuButtonClassName="p-0 mb-2"
          menuButtonLabel={
            <WebsiteHeaderLibraryElement
              libraryElement={LibraryElementEnum.LibraryMenu}
            />
          }
        >
          <WebsiteMenuSettings
            entity={menuEntity as MenuInterface}
            defaultEntity={defaultMenuEntity}
          />
        </SettingsNestedMenu>
      )}
      {isLogoEntity && (
        <SettingsNestedMenu
          menuTitle={t(
            libraryItems[LibraryElementEnum.LibraryWebsiteLogo]?.title,
          )}
          menuButtonClassName="p-0"
          menuButtonLabel={
            <WebsiteHeaderLibraryElement
              libraryElement={LibraryElementEnum.LibraryWebsiteLogo}
            />
          }
        >
          <WebsiteLogoSettings
            entity={websiteLogoEntity as WebsiteLogoInterface}
          />
        </SettingsNestedMenu>
      )}

      <div className="mt-1 mb-1 h-[1px] w-full bg-bgTertiary"></div>

      {toggleConfig.map(el => (
        <Toggle
          key={el}
          onChange={value => toggleElement(value, el)}
          checked={getToggleValue(el)}
          labelClassName="justify-between w-full"
          startElement={<WebsiteHeaderLibraryElement libraryElement={el} />}
        />
      ))}
    </div>
  )
}
